(function(window) {
    'use strict'

    const internal = window.RTAnalyticsInternal = window.RTAnalyticsInternal || {}
    const runtimeConfig = window.RT_ANALYTICS_CONFIG || {}

    internal.config = Object.freeze({
        databaseName: 'royalthai-analytics',
        databaseVersion: 2,
        eventStoreName: 'events',
        deliveryStoreName: 'deliveries',
        eventTtlMs: 7 * 24 * 60 * 60 * 1000,
        navigationWaitMs: 1000,
        maxFlushDeliveries: 50,

        getProviderConfig: function(providerName) {
            const providers = runtimeConfig.providers || {}
            return providers[providerName] || {}
        }
    })
})(window)
